// src/components/transfers/ReceiveDialog.jsx
import React, { useState } from 'react';
import { X } from 'lucide-react';

const ReceiveDialog = ({ transferNo, initialItems, onClose, onReceive }) => {
  const [items, setItems] = useState(initialItems);
  const [notes, setNotes] = useState('');
  const [receiving, setReceiving] = useState(false);

  const handleSubmit = async () => {
    setReceiving(true);
    try {
      await onReceive(transferNo, {
        received_items: items.map(i => ({ transfer_id: i.transfer_id, actual_quantity: parseInt(i.actual_quantity) })),
        notes,
      });
    } finally {
      setReceiving(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg">
        <div className="p-6 border-b flex justify-between items-center">
          <h3 className="text-lg font-bold">确认收货</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600"><X className="w-6 h-6" /></button>
        </div>
        <div className="p-6 space-y-4">
          <p className="text-sm text-gray-500">请核对实际收到的数量，如有差异请修改：</p>
          <div className="space-y-2">
            {items.map((item, idx) => (
              <div key={item.transfer_id} className="flex items-center justify-between bg-gray-50 p-3 rounded-lg">
                <div>
                  <p className="font-medium text-sm">{item.product_name}</p>
                  <p className="text-xs text-gray-500">
                    应收：{item.transfer_unit === 'box' && item.box_count
                      ? `${item.box_count} 箱（${item.quantity} 个）` : `${item.quantity} 个`}
                  </p>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="text-sm text-gray-500">实收（个）：</span>
                  <input type="number" min="0" max={item.quantity} value={item.actual_quantity}
                    onChange={e => { const n = [...items]; n[idx] = { ...n[idx], actual_quantity: e.target.value }; setItems(n); }}
                    className="w-20 px-2 py-1 border rounded-lg text-sm text-center" />
                </div>
              </div>
            ))}
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">收货备注</label>
            <textarea value={notes} onChange={e => setNotes(e.target.value)}
              className="w-full px-3 py-2 border rounded-lg text-sm" rows={2} placeholder="如有差异请说明（可选）" />
          </div>
        </div>
        <div className="p-6 border-t flex space-x-3">
          <button onClick={onClose} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">取消</button>
          <button onClick={handleSubmit} disabled={receiving}
            className={`flex-1 px-4 py-2 bg-purple-600 text-white rounded-lg ${receiving ? 'opacity-50 cursor-not-allowed' : 'hover:bg-purple-700'}`}>
            {receiving ? '确认中...' : '确认收货'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReceiveDialog;
